import styled from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {Hint} from 'components/ui-kit/Hint';
import {Modal} from 'components/ui-kit/Modal';
import {Title} from 'components/ui-kit/Title';
import {breakpoint, colors, font} from 'theme';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const CustomTitle = styled(Title)`
    color: #59606a;
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 0;
`;

export const TitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 40px;
    flex-wrap: wrap;
`;

export const FormFields = styled.div`
    display: grid;
    grid-row-gap: 10px;
    grid-column-gap: 30px;
    margin-bottom: 20px;

    @media (min-width: ${breakpoint.tablet}) {
        grid-template-columns: 1fr 1fr 1fr;
    }
`;

export const Field = styled(Hint)`
    display: flex;
    flex-flow: column wrap;

    > span {
        font-size: 12px;
        color: ${colors.textSecondary};
        padding-bottom: 6px;
        margin-top: 2px;
    }
`;

export const Actions = styled.div`
    display: flex;
    flex-flow: row nowrap;
    gap: 16px;
    justify-content: flex-end;
`;

export const SubmitButton = styled(Button)`
    max-width: 240px;
`;

export const AddButton = styled(Button)`
    max-width: 240px;
`;

export const BackButton = styled(Button)`
    max-width: 240px;
    color: ${colors.textPrimary};
    text-decoration: none;
`;

export const DeleteButton = styled(Button)<{$alignLeft?: boolean}>`
    max-width: 240px;
    margin-right: ${(props) => (props.$alignLeft ? 'auto' : 0)};
    border-color: ${colors.danger} !important;
    color: ${colors.danger};

    & > span {
        padding: 0 !important;
    }

    &:disabled {
        border-color: ${colors.textMuted} !important;
        color: ${colors.textMuted};
    }
`;

export const ConfirmDeleteButton = styled(Button)`
    max-width: 140px;
    background-color: #ff5252 !important;
    border-color: #ff5252 !important;
    color: ${colors.white};
`;

export const ConfirmRemoveFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`;

export const CancelConfirmButton = styled(Button)`
    max-width: 140px;
`;

export const RemoveConfirmationModal = styled(Modal)`
    [data-reach-dialog-content] {
        padding: 0;
        border-radius: 12px;
        box-shadow: 0 12px 32px rgba(52, 52, 52, 0.16);
        overflow: hidden;
    }
`;

export const ConfirmRemoveModalContent = styled.div`
    min-width: 432px;
`;

export const ConfirmRemoveHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 24px;
    border-bottom: 1px solid #ededed;
`;

export const ConfirmRemoveTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    color: ${colors.textPrimary};
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
`;

export const ConfirmRemoveHeaderIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #ffe5e5;
`;

export const ModalCloseButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
`;

export const WarningMessage = styled.div`
    margin: 16px 24px;
    padding: 12px;
    border: 1px solid #ffa726;
    border-radius: 8px;
    background: #fff4e6;
    color: ${colors.textPrimary};
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;

    p {
        margin: 0;
    }
`;
export const ConfirmBlockMessage = styled.p`
    text-align: center;
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: ${colors.textPrimary};
`;
